import * as React from "react";
import { CacheProvider } from "@emotion/react";
import { PrismicPreviewProvider } from "gatsby-plugin-prismic-previews";

import { myCache } from "utils";
import { repositoryConfigs } from "utils/prismic-previews";

const DELAY = 300;

export const wrapRootElement = ({ element }) => (
  <CacheProvider value={myCache}>
    <PrismicPreviewProvider repositoryConfigs={repositoryConfigs}>
      {element}
    </PrismicPreviewProvider>
  </CacheProvider>
);

export const shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition,
}) => {
  if (location.action === "PUSH") {
    window.setTimeout(() => window.scrollTo(0, 0), DELAY);
  } else {
    const savedPosition = getSavedScrollPosition(location);
    window.setTimeout(
      () => window.scrollTo(...(savedPosition || [0, 0])),
      DELAY,
    );
  }
  return false;
};
